// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { meter as _meter } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the meter chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 82
 * Chain Name: Meter
 * Default Block Explorer: https://scan.meter.io
 * Default RPC URL: https://rpc.meter.io
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { meter } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: meter,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const meter = createCommon({
	..._meter,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
